import { Input } from "antd";
import AddIcon from "components/Icons/AddIcon";
import { Link } from "react-router-dom";
import { Table, TableColumnsType } from "antd";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import { RouteName } from "constants/route";
import { SearchOutlined } from "@ant-design/icons";
import useNews from "hooks/broadcasts/useNews";
import { INews } from "models/broadcast";
import moment from "moment";
import { NewsAlertContextProvider } from "./components/AlertContext";
import Action from "./components/Action";

export default function News() {
  const {
    data: { data, loading, page, per_page, search, total },
    handlePageChange,
    handleSearch,
  } = useNews();

  return (
    <NewsAlertContextProvider>
      <div>
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.NEW_NEWS}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">Add New</span>
            </Link>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </NewsAlertContextProvider>
  );
}

const columns: TableColumnsType<INews> = [
  {
    title: "TITLE",
    dataIndex: "title",
    sortIcon,
  },
  {
    title: "CONTENT",
    dataIndex: "content",
    sortIcon,
  },
  {
    title: "DATE",
    dataIndex: "created_at",
    sortIcon,
    render: (text) => (
      <p className="whitespace-nowrap">{moment(text).format("ll")}</p>
    ),
  },
  {
    title: "ACTION",
    render: (news: INews) => <Action news={news} />,
  },
];
